module.exports = __webpack_public_path__ + "img/chuangxin.0df8d5bd.png";